"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPoller = exports.Poller = void 0;
var tslib_1 = require("tslib");
var intervalsMap = {
    short: 3000,
    normal: 5000,
    long: 10000
};
var defaultOptions = {
    interval: 'normal',
    maxRetries: 4,
    isPaused: function () { return false; },
    errorCb: function () { return false; },
    increaseIntervalFn: function (retries, interval) {
        // interval, interval * 3, interval * 9, interval * 27 / 2000, 6000, 18000, 54000
        return interval * Math.pow(3, retries);
    },
    disablePause: false,
};
var Poller = function (pollingApi, cb, options) {
    var timer;
    var retries = 0;
    var pollingEnded = false;
    var allOptions = tslib_1.__assign(tslib_1.__assign({}, defaultOptions), options);
    var maxRetries = allOptions.maxRetries, isPaused = allOptions.isPaused, errorCb = allOptions.errorCb, disablePause = allOptions.disablePause;
    var interval = typeof allOptions.interval === 'string' ? intervalsMap[allOptions.interval] : allOptions.interval;
    var poll = function () {
        if (!disablePause && isPaused()) {
            timer = setTimeout(function () { return poll(); }, interval);
        }
        else {
            var pollingResult = pollingApi();
            if (pollingResult) {
                pollingResult
                    .then(function (res) {
                    cb(res);
                    retries = 0;
                    if (!pollingEnded) {
                        timer = setTimeout(function () { return poll(); }, interval);
                    }
                })
                    .catch(function (error) {
                    var forceStop = errorCb(error, retries);
                    if (!forceStop) {
                        retries++;
                        if (retries < maxRetries) {
                            if (!pollingEnded) {
                                timer = setTimeout(function () { return poll(); }, allOptions.increaseIntervalFn(retries, interval, error));
                            }
                        }
                    }
                    else {
                        endPolling();
                    }
                });
            }
        }
    };
    poll();
    var endPolling = function () {
        clearTimeout(timer);
        pollingEnded = true;
    };
    return endPolling;
};
exports.Poller = Poller;
var SmartPoller = function (pollingApi, cb, options) {
    var isPausedOrDocumentHiddenOrOffline = function () {
        var paused = options.isPaused && options.isPaused();
        var hiddenTabPause = !options.disableHiddenTabPause && options.document.visibilityState === 'hidden';
        return paused || hiddenTabPause || options.navigator.onLine === false;
    };
    var combinedOptions = tslib_1.__assign(tslib_1.__assign({}, options), { isPaused: isPausedOrDocumentHiddenOrOffline });
    var endPolling = (0, exports.Poller)(pollingApi, cb, combinedOptions);
    return endPolling;
};
exports.SmartPoller = SmartPoller;
//# sourceMappingURL=index.js.map